import axios from 'axios';

const sendMail = data => {
	return axios.post('https://formsubmit.co/ajax/business@chatbiz.id', data);
};

export default sendMail;
